import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 49.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 49rem;
  overflow-y: hidden;
  z-index: -1;
  & > img {
    position: absolute;
    z-index: -999;
    width: 192rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 9rem;
    height: 70rem;
    position: relative;

    z-index: 0;
    overflow: hidden;
    width: 37.5rem;
    margin-left: -20px;
    padding-left: 20px;
    & > img {
      position: absolute;
      z-index: -999;
      top: 0;
      width: 38.3rem;
      margin-left: -20px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    gap: 3rem;
    flex-direction: column;
    position: relative;
    margin-bottom: 26rem;
    height: 60rem;
  }
`;

export const TextBox1 = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10rem;
  & > div:nth-child(1) {
    font-weight: 700;
    font-size: 5.2rem;
    line-height: 9.2rem;
  }
  & > div:nth-child(2) {
    margin-top: 1rem;
    font-weight: 300;
    font-size: 2rem;
    line-height: 3.6rem;
    display: flex;
    flex-direction: column;
  }
  & > div:nth-child(3) {
    margin-top: 6rem;
    display: flex;
    gap: 2rem;

    & > a > img {
      width: 15rem;
      height: 4.5rem;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    height: auto;
    padding-top: 14rem;
    & > div:nth-child(1) {
      font-size: 3.2rem;
      line-height: 5.4rem;
    }
    & > div:nth-child(2) {
      font-size: 1.8rem;
      line-height: 3.2rem;
      display: block;
    }
    & > div:nth-child(3) {
      margin-top: 3rem;
      display: flex;
      gap: 2rem;

      & > img {
        width: 15rem;
        height: 4.5rem;
      }
    }
  }
`;
export const ImgBox1 = styled.div`
  width: 49.5rem;
  height: 60rem;

  & > img {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 29.7rem;
    height: 37.2rem;
    margin-top: 5rem;
    position: absolute;
    bottom: -27rem;
    left: 2rem;
  }
`;
